import React, { Component } from "react";
import Paper from "@mui/material/Paper";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TablePagination from "@mui/material/TablePagination";
import TableRow from "@mui/material/TableRow";
import EditIcon from "@mui/icons-material/Edit";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import SettingsIcon from "@mui/icons-material/Settings";
import BusinessIcon from "@mui/icons-material/Business";
import commStyles from "../../../common/styles";
import "./styles.css";
import { PleaseWait } from "../PleaseWait";
const { IconWhiteHover } = commStyles;

class RenderTable extends Component {
  state = {
    page: 0,
    rowsPerPage: this.props.rowsPerPage || 5,
  };

  handleChangePage = async (event, newPage) => {
    const response = await this.props.handleChangePage(
      newPage,
      this.state.rowsPerPage
    );
    if (response) {
      this.setState({
        page: newPage,
      });
    }
  };

  handleChangeRowsPerPage = (event) => {
    this.setState({
      page: 0,
      rowsPerPage: +event.target.value,
    });
    this.props.handleChangePage(0, +event.target.value);
  };

  render() {
    return (
      <Paper
        sx={{
          width: "100%",
          overflow: "hidden",
          maxHeight: this.props.maxHeight,
        }}
      >
        <TableContainer
          className="style-1"
          sx={{
            height: "auto",
            minHeight: "400px",
            maxHeight: "none",
            overflowX: "auto"
          }}
        >
          <Table stickyHeader aria-label="sticky table">
            <TableHead>
              <TableRow>
                {this.props.columns.map((column) => (
                  <TableCell
                    sx={{
                      backgroundColor: "rgb(235, 233, 233);",
                      textAlign: "center",
                      fontSize: "13px",
                      fontWeight: "bold",
                      color: "rgb(65, 67, 69)",
                      fontFamily:
                        'Montserrat, "PT Sans Caption", Arial, sans-serif',
                      textTransform: "uppercase",
                      padding: "10px",
                    }}
                    key={column.id}
                    align={column.align}
                    style={{ minWidth: column.minWidth }}
                  >
                    {column.label}
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {this.props.dataValues
                .slice(
                  this.state.page * this.state.rowsPerPage,
                  this.state.page * this.state.rowsPerPage +
                    this.state.rowsPerPage
                )
                .map((row) => {
                  return (
                    <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                      {this.props.columns.map((column) => {
                        const value = row[column.id];
                        return (
                          <TableCell
                            sx={{
                              borderRight: "1px solid rgb(238, 238, 238)",
                              textAlign: "center",
                            }}
                            key={column.id}
                            align={column.align}
                          >
                            {
                              // customized table cells !!!
                              column.id == "operationEditDelete" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.editModel(row);
                                    }}
                                  >
                                    <EditIcon />
                                  </IconWhiteHover>
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.deleteEntry(row);
                                    }}
                                  >
                                    <DeleteForeverIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "status" &&
                                row.status == "sold" ? (
                                `${value} (BuyerId: ${row.buyerId})`
                              ) : column.id == "operationDelete" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.deleteEntry(row);
                                    }}
                                  >
                                    <DeleteForeverIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "settingActions" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.settingActionsClick(row);
                                    }}
                                  >
                                    <SettingsIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "userAddresses" ? (
                                <div
                                  style={{
                                    display: "flex",
                                    flexDirection: "row",
                                    justifyContent: "center",
                                  }}
                                >
                                  <IconWhiteHover
                                    onClick={() => {
                                      this.props.openAddress(row);
                                    }}
                                  >
                                    <BusinessIcon />
                                  </IconWhiteHover>
                                </div>
                              ) : column.id == "isAvailableForPrebooking" ? (
                                value === true || value === "true" || value === 1 || value === "1" ? "Yes" : "No"
                              ) : column.format && typeof value === "number" ? (
                                column.format(value)
                              ) : (
                                value
                              )
                            }
                          </TableCell>
                        );
                      })}
                    </TableRow>
                  );
                })}
            </TableBody>
          </Table>
          {this.props.dataValues.length == 0 && !this.props.stopPleaseWait ? (
            <PleaseWait />
          ) : (
            ""
          )}
        </TableContainer>
        <TablePagination
          sx={{
            display: "flex",
            justifyContent: "center",
          }}
          rowsPerPageOptions={[5, 20, 50, 100]}
          component="div"
          count={this.props.totalSize}
          rowsPerPage={this.state.rowsPerPage}
          page={this.state.page}
          onPageChange={this.handleChangePage}
          onRowsPerPageChange={this.handleChangeRowsPerPage}
        />
      </Paper>
    );
  }
}

export default RenderTable;
